import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;
// background-color: #1a1a2e;

export const TopRightContainer = styled.div`
  position: absolute;
  top: 40px;
  right: 40px;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: 768px) {
    top: 20px;
    right: 20px;
    gap: 10px;
  }
`;

export const LanguageSelectorContainer = styled.div`
  button {
    background: rgba(255, 255, 255, 0.95) !important;
    border: 2px solid rgba(255, 255, 255, 0.8) !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4) !important;

    &:hover {
      background: rgba(255, 255, 255, 1) !important;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;
    }
  }
`;

export const ActionButton = styled.button`
  width: 48px;
  padding: 0;
  height: 48px;
  border: ${(props) =>
    props.reprint ? "2px solid rgba(255, 255, 255, 0.5)" : "none"};
  border-radius: 50%;
  background-color: ${(props) =>
    props.reprint ? "white" : "transparent"} !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  gap: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  position: relative;
  z-index: 1000;
  pointer-events: auto;
  font-size: 18px;

  /* Reset any inherited transitions or transforms */
  transition: all 0.3s ease !important;
  transform: none !important;

  /* Define hover effects for all buttons */
  &:hover {
    background: ${(props) =>
      props.reprint
        ? "rgba(255, 255, 255, 1)"
        : "rgba(255, 255, 255, 0.1)"} !important;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25) !important;
    transition: all 0.3s ease !important;
    transform: translateY(-2px) scale(1.05) !important;
  }

  &:active {
    background: ${(props) =>
      props.reprint
        ? "rgba(255, 255, 255, 1)"
        : "rgba(255, 255, 255, 0.2)"} !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
    transform: translateY(0) scale(1) !important;
  }

  &:focus {
    outline: none !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4) !important;
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
  }
`;

// Container para a imagem de fundo
export const BackgroundImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1a1a2e;
  z-index: -1;
  overflow: hidden;
`;

// Imagem de fundo usando tag img
export const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: -1;
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const AnimatedContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${(props) => (props.withTitle ? "column" : "row")};
  width: 100%;
  height: 100%;
  padding: 60px;
  z-index: 1;
  animation: ${slideIn} 0.8s ease-out;
  justify-content: space-between;

  @media (max-width: 1366px) {
    padding: 40px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 50px;
  padding-left: 90px;

  @media (max-width: 768px) {
    align-items: center;
    padding-top: 30px;
    margin-bottom: 50px;
  }
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  padding-right: 180px;

  @media (max-width: 768px) {
    padding: 20px 0;
  }
`;

export const Logo = styled.img`
  width: 520px;
  height: auto;
  max-width: 100%;
  margin-bottom: 90px;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.35));

  @media (max-width: 1366px) {
    width: 460px;
    margin-bottom: 70px;
  }

  @media (max-width: 768px) {
    width: 360px;
    margin-bottom: 50px;
  }
`;

export const EventImage = styled.img`
  width: 480px;
  height: auto;
  max-width: 100%;
  border-radius: 18px;
  filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.45));

  @media (max-width: 1366px) {
    width: 420px;
  }

  @media (max-width: 768px) {
    width: 340px;
  }
`;

export const CpfSection = styled.div`
  margin-bottom: 40px;
  text-align: center;
`;

export const CpfLabel = styled.label`
  font-size: 32px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 30px;
  display: block;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

export const CpfInput = styled.input`
  width: 580px;
  height: 90px;
  font-size: 32px;
  font-weight: 500;
  text-align: center;
  color: #333;
  background: #ffffff;
  border: none;
  border-radius: 15px;
  padding: 0 28px;
  letter-spacing: 3px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);
  }

  &::placeholder {
    color: #999;
    letter-spacing: 3px;
  }

  @media (max-width: 768px) {
    width: 450px;
    height: 75px;
    font-size: 28px;
  }
`;

export const Calculator = styled.div`
  width: 580px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 28px;
  padding: 45px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 450px;
    padding: 36px;
  }
`;

export const NumberGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 24px;
  }
`;

const buttonBase = styled.button`
  width: 100%;
  height: 120px;
  border: none;
  border-radius: 20px;
  font-size: 34px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
  user-select: none;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.18);
  }

  @media (max-width: 768px) {
    height: 100px;
    font-size: 30px;
  }
`;

export const NumberButton = styled(buttonBase)`
  background: #f8f9fa;
  color: #2c3e50;
  border: 2px solid #e9ecef;

  &:hover {
    background: #e9ecef;
    border-color: #dee2e6;
  }
`;

export const BackspaceButton = styled(buttonBase)`
  background: #2c3e50;
  color: #ffffff;
  font-size: 38px;

  &:hover {
    background: #34495e;
  }

  @media (max-width: 768px) {
    font-size: 34px;
  }
`;

export const SubmitButton = styled(buttonBase)`
  background: #4caf50;
  color: #ffffff;
  font-size: 22px;
  font-weight: 600;

  &:hover {
    background: #45a049;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const SubmitButtonPP = styled(buttonBase)`
  background: #4caf50;
  color: #ffffff;
  font-size: 22px;
  font-weight: 600;
  height: 90px;

  &:hover {
    background: #45a049;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const CredentialsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  padding: 10px;
  width: 100%;
  height: calc(100vh - 250px);
  max-height: 70vh;
  overflow-y: auto;
  margin: 10px auto 40px;

  /* Custom scrollbar styles */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    transition: background 0.3s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const CredentialCard = styled.div`
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.16);
  width: 40%;
  min-width: 500px;
  height: 330px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #ffffff 35%,
    #ededed 55%,
    #dcdcdc 100%
  );
`;

export const CredentialsPageTitle = styled.h3`
  font-size: 32px;
  font-weight: 600;
  color: #ffffff;
  text-align: start;
  white-space: nowrap;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  margin-bottom: 0 !important;
  margin-top: 10px !important;
`;

export const LabelCard = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  white-space: nowrap;

  span {
    font-weight: 700;
    color: rgba(0, 0, 0, 0.8);
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: auto;
`;

export const PrintButton = styled.button`
  background: ${(props) =>
    props.printed
      ? "rgba(254, 202, 202, 1)"
      : "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)"};

  border: ${(props) =>
    props.printed ? "none" : "2px solid rgba(134, 239, 172, 0.8)"};

  box-shadow: ${(props) =>
    props.printed
      ? "none"
      : `
        0 0 10px rgba(34, 197, 94, 0.8),
        0 0 20px rgba(34, 197, 94, 0.6),
        0 0 40px rgba(34, 197, 94, 0.4)
      `};

  color: ${(props) => (props.printed ? "rgba(0, 0, 0, 0.85)" : "#fff")};

  border-radius: 8px;
  padding: 10px 20px;
  font-size: ${(props) => (props.printed ? "18px" : "22px")};
  font-weight: 700;
  text-transform: ${(props) => (props.printed ? "none" : "uppercase")};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;

  cursor: ${(props) => (props.printed ? "not-allowed" : "pointer")};
  margin-top: 15px;
  transition: all 0.25s ease;

  &:hover {
    transform: ${(props) =>
      props.printed ? "none" : "translateY(-2px) scale(1.03)"};

    box-shadow: ${(props) =>
      props.printed
        ? "none"
        : `
          0 0 15px rgba(34, 197, 94, 1),
          0 0 30px rgba(34, 197, 94, 0.8),
          0 0 60px rgba(34, 197, 94, 0.6)
        `};
  }
`;

export const AreaTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
`;

export const ReturnButton = styled.button`
  background: #ffffff;
  border: none;
  color: #000000;
  width: fit-content;
  height: auto;
  font-size: 22px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  gap: 15px;
  align-self: flex-start;

  &:hover {
    background: #e0e0e0;
  }
`;

export const CredencialsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
